import React, { useEffect, useState } from "react";
import '../../reusables/ModalInput/ModalInputStyles.css';
import EnhancedTable from '../../reusables/TableComponent/TableComponent';
//modal
import CloseIcon from '@mui/icons-material/Close';
import { saveAs } from "file-saver";
import Cookies from 'js-cookie';
import Multiselect from 'multiselect-react-dropdown';
import Modal from "react-bootstrap/Modal";
import { useLocation, useNavigate } from 'react-router-dom';
import CollegeData from '../../../CollegeDataServices/httpCollege';
import Service from '../../../services/httpService';
import { UserTypeContext as RowsContext } from "../../pages/RowsContext/RowsContext";
import Loader from "../../reusables/Loader/Loader";
import SideNavigationBar from '../../reusables/SideNavigationBar/SideNavigationBar';
import TopBar from '../../reusables/TopBar/Topbar';

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ArrowBack } from "@mui/icons-material";


const UserType = () => {
	const location = useLocation();
	let college_data_id = location.state?.college_id
	let college_data_name = location.state?.college_name || ""
	const [loading, setLoading] = useState(true);
	const [specializationData, setSpecializationData] = useState([])
	const [specialization_ids, setSpecialization_ids] = useState([])
	const collegeData = new CollegeData()
	const service = new Service()
	const navigate = useNavigate();

	// batch data
	const [BatchData, setBatchData] = useState([])
	const [formLink, setFormLink] = useState(null)

	const [rowsData, setRowsData] = useState([{ id: null, user_group_name: "", acad_year: "", program_type_id: null, batch_type_id: null, college_id: "", specializations_allowed: [] }])
	const [rowsData_mod_id, setRowsData_mod_id] = useState([])
	const [rowsData_mod_key, setRowsData_mod_key] = useState([])

	//from table index
	const [from_table, setFrom_table] = useState();

	// getter of batch and program
	const [roleData, setRoleData] = useState([])
	const [batchTypeData, setbatchTypeData] = useState([])
	const [programData, setProgramData] = useState([])

	const [batchType, setBatchType] = useState()
	const [program, setProgram] = useState()
	const [jd_batch_id, setJd_batch_id] = useState();
	const [jd_program_id, setJd_program_id] = useState();
	const [loader, setLoader] = useState(false);
	const [jd_input_name, setJd_input_name] = useState(BatchData[from_table?.index]?.user_group_name);


	//get current date and time
	const currentDate = new Date();
	const [specialization_select_data, setSpecialization_select_data] = useState([])
	const [batch_select_data, setBatch_select_data] = useState()

	// const [count, setCount] = useState()
	let count = 0;

	const currentYear = new Date().getFullYear();
	const isAfterAugust = new Date().getMonth() >= 8;
	const firstAcademicYear = 2021;
	const academicYear =
		currentYear >= firstAcademicYear &&
			(currentYear > firstAcademicYear || isAfterAugust)
			? `${currentYear}-${(currentYear + 1).toString().slice(2)}`
			: `${currentYear - 1}-${currentYear.toString().slice(2)}`;
	const previousYear = `${currentYear - 1}-${currentYear.toString().slice(2)}`;
	const nextYear = `${currentYear + 1}-${(currentYear + 2).toString().slice(2)}`;
	const options =
		currentYear >= firstAcademicYear && isAfterAugust
			? [academicYear, nextYear, `${currentYear + 2}-${(currentYear + 3).toString().slice(2)}`]
			: [
				`${currentYear - 1}-${currentYear.toString().slice(2)}`,
				`${currentYear}-${(currentYear + 1).toString().slice(2)}`,
				`${currentYear + 1}-${(currentYear + 2).toString().slice(2)}`,
			];

	//activity
	const [activity, setActivity] = useState("");


	const [selectedYear, setSelectedYear] = useState(BatchData[from_table?.index]?.acad_year);


	const headCells = [
		{
			id: 'heading1',
			numeric: 'right',
			disablePadding: false,
			label: 'Batch Name',
		},
		{
			id: 'heading2',
			numeric: 'right',
			disablePadding: false,
			label: 'Academic Year',
		},
		{
			id: 'heading2',
			numeric: 'right',
			disablePadding: false,
			label: 'Program Type',
		},
		{
			id: 'heading2',
			numeric: 'right',
			disablePadding: false,
			label: 'Batch Type',
		},


	];

	const handleDeleteMul = (id, index) => {

		let list = [...BatchData];



		collegeData
			.delete("/userGroup", {
				data: { "ids": id }
			})
			.then((res) => {

				list = list.filter((item) => id.indexOf(item.id) < 0);
				setRowsData(list)
				setBatchData(list)



			})
			.catch((err) => {
				console.log("Errog Msg: ", err);
			});
	}

	const handleProcessDataPage = (id, name) => {

		navigate(`${"/ProcessData?user_group_id=" + id}`, { state: { batch_id: id, batch_name: name, college_name: college_data_name, } })
	}

	const handleStudentDataPage = (id, name) => {

		navigate(`${"/StudentData?user_group_id=" + id}`, { state: { batch_id: id, batch_name: name, college_name: college_data_name, } })
	}

	const data_getter = (name, id, index, act) => {

		setActivity(act);
		if (name === "delete_mul") {

			handleDeleteMul(id, index)
		}
		else if (name === "BatchData") {

			handleProcessDataPage(id)
		}
		else if (name === "StudentData") {
			handleStudentDataPage(id)
		}
		if (act === "add") {
			setJd_input_name()
			setSelectedYear()
			setJd_batch_id()
			setJd_program_id()
			setSpecialization_select_data()
		}
		else if ((name === undefined || name === null) && (id !== undefined || id !== null || id !== 0)) {
			handleDelete(id, index);
		}



		setFrom_table({ ...from_table, id: typeof id === "number" ? id : undefined, index: typeof index === "number" ? index : undefined })
	}

	const batchDataGetter = async () => {
		try {
			const res = await collegeData.get(`/userGroup/byCollege?collegeId=${college_data_id}`)

			setBatchData([...res.data])
			setRowsData_mod_id([...res.data])
			setRowsData_mod_key([...res.data])
			setRowsData([...res.data])
			return res.data
		} catch (err) {
			console.log(err)
		}
	}

	const batchGetter = async () => {

		try {
			const res = await service.get('/batchType')

			setbatchTypeData(res.data)
			return res.data
		} catch (err) {
			console.log(err)
		}
	}
	const programGetter = async () => {
		try {
			const res = await service.get('/programType')

			setProgramData(res.data)
			return res.data
		} catch (err) {
			console.log(err)
		}
	}

	// specialization
	const specializationGetter = async () => {
		try {
			const res = await service.get('/specialization?is_admin=1')

			let temp = res.data;
			temp = temp.map(bat => {
				bat.key = bat.name;
				bat.id = bat.id;

				delete bat.name;
				return bat;
			});
			setSpecializationData(temp)
			return res.data
		} catch (err) {
			console.log(err)
		}
	}

	const JoinLinkGetter = async () => {
		try {
			const res = await service.get(`${process.env.REACT_APP_API_URL}/superAdmin/colleges/form-details/${college_data_id}`)
			return res.data[0]
		} catch (err) {
			console.log(err)
			return null
		}
	}

	// get request
	useEffect(() => {

		const handleEffect = async () => {

			if (Cookies.get('token') === null || Cookies.get('token') === undefined) {
				navigate('/');
			}
			await batchDataGetter();

			const batch = await batchGetter();

			const program = await programGetter();

			const joinLink = await JoinLinkGetter()
			await specializationGetter()
			setFormLink(joinLink)
			data_manupulator_batch(batch);
			data_manupulator_program(program);
			setLoading(false)
		}

		handleEffect();
	}, [])

	useEffect(() => {
		const setting_data = () => {

			if (from_table?.index === undefined) {

				setJd_input_name()
				setSelectedYear()
				setJd_batch_id()
				setJd_program_id()
				setBatch_select_data([])
				setSpecialization_ids([])
				setSpecialization_select_data()

				setSpecializationData(specializationData)
			}
			else {
				//setting values for Edit Modal

				setJd_input_name(BatchData[from_table?.index]?.user_group_name)
				setSelectedYear(BatchData[from_table?.index]?.acad_year)

				setJd_program_id(BatchData[from_table?.index]?.program_type_id)
				setJd_batch_id(BatchData[from_table?.index]?.batch_type_id)
				// setJd_program_id(jdData[from_table?.index]?.program_type_ids)
				const temp_ids = typeof BatchData[from_table?.index]?.specializations_allowed === 'string' ? JSON.parse(BatchData[from_table?.index]?.specializations_allowed) : BatchData[from_table?.index]?.specializations_allowed

				const find_batch = specializationData.filter((ele) => temp_ids?.ids ? temp_ids?.ids?.includes(ele.id) : temp_ids?.includes(ele.id));

				setSpecialization_select_data(find_batch)

				setSpecializationData(specializationData)
				//setProgram_select_data()
				// setBatch_select_data()
				// clean_rowsData_mod_batch_type_id(rowsData_mod_id[from_table?.index] ? rowsData_mod_id[from_table?.index] : [], rowsData_mod_key[from_table?.index] ? rowsData_mod_key[from_table?.index] : [])
				// clean_rowsData_mod_program_type_id(rowsData_mod_id[from_table?.index] ? rowsData_mod_id[from_table?.index] : [], rowsData_mod_key[from_table?.index] ? rowsData_mod_key[from_table?.index] : [])
			}

		}
		setting_data();
	}, [from_table])






	// const data_manupulator_jd = (jd, role, batch, program, from) => {

	// 	let temp_rowsData = JSON.parse(JSON.stringify(jd));
	// 	let temp_role = JSON.parse(JSON.stringify(role));
	// 	let temp_batch = JSON.parse(JSON.stringify(batch));
	// 	let temp_program = JSON.parse(JSON.stringify(program));

	// 	//show data - send to Table Component
	// 	temp_rowsData.forEach((row) => {

	// 		row.role_id = temp_role?.map(data => data.id === row.role_id ? data.name : "")?.filter(value => value !== "")[0]
	// 		// row.batch_type_id = JSON.parse(row.batch_type_id).ids.map(data => temp_batch.map(bat => data === bat.id ? bat.name : "").filter(value => value !== ""))
	// 		// row.program_type_id = JSON.parse(row.program_type_id).ids.map(data => temp_program.map(pro => data === pro.id ? pro.name : "").filter(value => value !== ""))
	// 		delete row.batch_type_id
	// 		delete row.program_type_id
	// 		delete row.file_version
	// 		delete row.active_flag

	// 	});

	// 	setRowsData(temp_rowsData)


	// 	//id - for the batch type
	// 	let temp_rowsData_mod_id = JSON.parse(JSON.stringify(jd));
	// 	temp_rowsData_mod_id.forEach((row) => {

	// 		row.role_id = temp_role?.map(data => data.id === row.role_id ? data.name : "")?.filter(value => value !== "")[0]
	// 		row.batch_type_id = JSON.parse(row.batch_type_id).ids?.map(data => temp_batch?.map(bat => data === bat.id ? bat.id : "")?.filter(value => value !== ""))
	// 		row.program_type_id = JSON.parse(row.program_type_id).ids?.map(data => temp_program?.map(pro => data === pro.id ? pro.id : "")?.filter(value => value !== ""))
	// 		delete row.file_url
	// 		delete row.file_version
	// 		delete row.active_flag

	// 	});

	// 	setRowsData_mod_id(temp_rowsData_mod_id)




	// 	//key - for the program type
	// 	let temp_rowsData_mod_key = JSON.parse(JSON.stringify(jd));
	// 	temp_rowsData_mod_key.forEach((row) => {

	// 		row.role_id = temp_role?.map(data => data.id === row.role_id ? data.name : "")?.filter(value => value !== "")[0]
	// 		row.batch_type_id = JSON.parse(row.batch_type_id).ids?.map(data => temp_batch?.map(bat => data === bat.id ? bat.name : "")?.filter(value => value !== ""))
	// 		row.program_type_id = JSON.parse(row.program_type_id).ids?.map(data => temp_program?.map(pro => data === pro.id ? pro.name : "")?.filter(value => value !== ""))
	// 		delete row.file_url
	// 		delete row.file_version
	// 		delete row.active_flag

	// 	});

	// 	setRowsData_mod_key(temp_rowsData_mod_key)

	// 	//JSON parsing jdData
	// 	let temp_jdData = JSON.parse(JSON.stringify(jd));
	// 	temp_jdData.forEach((row) => {

	// 		row.batch_type_id = JSON.parse(row.batch_type_id)?.ids
	// 		row.program_type_id = JSON.parse(row.program_type_id)?.ids

	// 	});

	// 	setBatchData(temp_jdData)




	// }

	const data_manupulator_batch = (batch) => {

		let temp = batch;
		temp = temp.map(bat => {
			bat.key = bat.name;
			bat.id = bat.id;
			return bat;
		});

		setBatchType(temp)
	}


	const data_manupulator_program = (program) => {

		let temp = program;
		temp = temp.map(pro => {
			pro.key = pro.name;
			pro.id = pro.id;
			return pro;
		});

		setProgram(temp)
	}





	//MODAL
	const Modal_JD = (show, setShow, mode) => {


		const modalSubmit = async () => {

			let temp_jdData
			setLoader(true);
			if (activity === "add")
				temp_jdData = await handleFormSubmission(jd_input_name, selectedYear, jd_program_id, jd_batch_id, college_data_id, specialization_ids);
			else
				temp_jdData = await handlePutRequest(BatchData[from_table?.index].id, jd_input_name, selectedYear, jd_program_id, jd_batch_id, college_data_id, specialization_ids);

			setShow(false)
			setLoader(false);
			window.location.reload();
		}

		const onHide = () => {
			setShow(false)
			setJd_input_name()
			setSelectedYear()
			setJd_batch_id()
			setJd_program_id()
		}

		const handleChange = (e, index) => {


			if (e.target.name === "jd-input") {
				setJd_input_name(e.target.value)

			}

			else if (e.target.name === "batch-select") {
				setJd_batch_id(e.target.value)


			}
			else if (e.target.name === "program-select") {
				setJd_program_id(e.target.value)

			}
			else if (e.target.name === "academicYear") {
				setSelectedYear(e.target.value);
			}

		}

		const onSelect_specialization = (e) => {

			let temp = JSON.parse(JSON.stringify(e));
			temp = temp.filter(data => typeof data.id === "number").map(obj => obj.id)
			setSpecialization_ids(temp)

		}

		// multiselect on remove method
		const onRemove_specialization = (e) => {

			setSpecialization_select_data(e);
			let temp = JSON.parse(JSON.stringify(e));
			temp = temp.filter(data => typeof data.id === "number").map(obj => obj.id)
			//   data.id = data.id;
			//   return data;
			// });
			setSpecialization_ids(temp)

		}

		//render
		return (
			<Modal
				show={show}
				onHide={() => setShow(false)}
				className="FileUploadModal"
				size="sm"
				aria-labelledby="contained-modal-title-vcenter"
				centered
				style={{ backdropFilter: "blur(5px)", minWidth: "80%", maxWidth: "95%", minHeight: "80%", maxHeight: "95%" }}
			>
				<Modal.Body style={{
					position: 'absolute',
					left: '60%',
					height: 'auto',
					transform: 'translate(-50%, -50%)',
					lineHeight: '1.4',
					padding: '14px 28px',
					backgroundColor: '#fff',
					borderRadius: '10px',
					maxWidth: '95%',
					minWidth: '500px',
					minHeight: '400px'
				}}>
					<form className="Entire-form" style={{ justifyContent: 'center' }}>
						{/* right side components */}
						<div className='row full-div' >
							<div style={{ display: "flex", flexDirection: "row", justifyContent: "center" }}>
								<CloseIcon className="closeIcon" onClick={((e) => onHide(e))} />
								<p className="compTitle" style={{ fontSize: "32px", textAlign: "center", background: 'transparent' }}>Batch/User Group </p>
							</div>

							<div className="form-group">
								<label className="inputLabel">Batch Name<span>*</span></label>
								<input name="jd-input" disabled={mode === "View" ? true : false} type="text" className="form-control" placeholder="Example input" value={jd_input_name} onChange={(e) => handleChange(e)} />
							</div>
							<div className="form-group">
								<label className="inputLabel" htmlFor="academicYear">Select academic year:</label>
								<select id="academicYear" disabled={mode === "View" ? true : false} name="academicYear" className="form-control inputFields" value={selectedYear} onChange={(e) => handleChange(e)}>
									<option className="options-value" value={""} disabled selected>Select academic year</option>
									{options.map((option) => (
										<option key={option} value={option}>
											{option}
										</option>
									))}
								</select>
							</div>
							<div className="form-group ">
								<label className="inputLabel">Program Type<span>*</span></label>
								{/* <input type="text" className="form-control inputFields" placeholder="Example input" /> */}
								<select name="program-select" disabled={mode === "View" ? true : false} id="selectList" className="form-control inputFields" onChange={(e) => handleChange(e)} value={jd_program_id}>
									<option className="options-value" value={""} disabled selected>Select Program Type</option>
									{program?.map((pro, i) => (
										<option key={i} value={pro.id}>{pro.key}</option>
									))}
								</select>
							</div>
							<div className="form-group ">
								<label className="inputLabel">Batch Type<span>*</span></label>
								<select name="batch-select" disabled={mode === "View" ? true : false} id="selectList" className="form-control inputFields" onChange={(e) => handleChange(e)} value={jd_batch_id}>
									<option className="options-value" value={""} disabled selected>Select Batch Type</option>
									{batchType?.map((bat, i) => (
										<option key={i} value={bat.id}>{bat.key}</option>
									))}
								</select>
							</div>
							<div className="form-group">
								<label className="inputLabel">Specialization Type<span>*</span></label>
								<Multiselect
									displayValue="key"
									selectedValues={specialization_select_data}
									onRemove={(e) => onRemove_specialization(e)}
									onSelect={(e) => { onSelect_specialization(e) }}
									options={specializationData}
								/>
							</div>
							<div className="form-group ">

								{mode === "View" ? <></> : <div className=" btn-comp " style={{ marginTop: "4%" }}>
									<button type="button" onClick={modalSubmit} disabled={loader} className="btn submit-btn">{loader ? "Loading..." : "Submit"}</button>
								</div>}
							</div>
						</div>
					</form>
				</Modal.Body>
			</Modal>
		)
	}


	// post request
	const handleFormSubmission = async (user_group_name, acad_year, program_type_id, batch_type_id, college_data_id) => {
		let temp_rows = [...rowsData];
		let temp_batchData = JSON.parse(JSON.stringify(BatchData));
		let data = {
			user_group_name: user_group_name,
			acad_year: acad_year,
			program_type_id: parseInt(program_type_id),
			batch_type_id: parseInt(batch_type_id),
			college_id: college_data_id,
			specializations_allowed: specialization_ids
		}
		await collegeData
			.post("/userGroup", data)
			.then(async (res) => {

				let temp = JSON.parse(JSON.stringify(rowsData));
				let temp_program = programData;
				let temp_batch = batchType

				temp = ([{
					id: res?.data?.id,
					user_group_name: user_group_name,
					acad_year: acad_year,
					program_type_id: parseInt(jd_program_id),
					batch_type_id: parseInt(jd_batch_id),
					college_id: college_data_id,
					specializations_allowed: specialization_ids
				}, ...temp])

				setRowsData(temp)


				temp_batchData = ([{
					id: res?.data?.id,
					user_group_name: user_group_name,
					acad_year: acad_year,
					program_type_id: parseInt(jd_program_id),
					batch_type_id: parseInt(jd_batch_id),
					college_id: college_data_id,
					specializations_allowed: specialization_ids
				}, ...temp_batchData])


				if (formLink) {
					const body = {
						form_details: JSON.stringify({ name: "", contact: "" }),
						programs: temp_batchData,
						is_active: formLink.is_active
					}

					await service.put(`${process.env.REACT_APP_API_URL}/superAdmin/colleges/form-details/${college_data_id}`, body)


				}

				setBatchData(temp_batchData)

			})
			.catch((err) => {

				window.alert(err.response.data.message)
			});
		return temp_batchData
	}

	const handlePutRequest = async (id, jd_input_name, selectedYear, jd_program_id, jd_batch_id, college_data_id) => {
		//get request here
		let temp_batchData = JSON.parse(JSON.stringify(BatchData));

		try {
			const res = await collegeData.put("/userGroup", {
				id: id,
				user_group_name: jd_input_name,
				acad_year: selectedYear,
				program_type_id: parseInt(jd_program_id),
				batch_type_id: parseInt(jd_batch_id),
				college_id: college_data_id,
				specializations_allowed: specialization_ids
			})


			let temp = JSON.parse(JSON.stringify(rowsData));


			temp[from_table?.index].user_group_name = jd_input_name
			temp[from_table?.index].acad_year = selectedYear
			temp[from_table?.index].program_type_id = parseInt(jd_program_id)
			temp[from_table?.index].batch_type_id = parseInt(jd_batch_id)
			temp[from_table?.index].college_id = college_data_id
			temp[from_table?.index].specializations_allowed = specialization_ids


			setRowsData(temp)


			temp_batchData[from_table?.index].user_group_name = jd_input_name
			temp_batchData[from_table?.index].acad_year = selectedYear
			temp_batchData[from_table?.index].program_type_id = parseInt(jd_program_id)
			temp_batchData[from_table?.index].batch_type_id = parseInt(jd_batch_id)
			temp_batchData[from_table?.index].college_id = college_data_id
			temp_batchData[from_table?.index].specializations_allowed = specialization_ids

			setBatchData(temp_batchData)


		} catch (err) {

			window.alert(err.response.data.message)
		};
		return temp_batchData
	}

	// delete request
	const handleDelete = async (jd_id, index) => {

		let list = [...rowsData];


		collegeData
			.delete("/userGroup", {
				data: { "ids": [jd_id] }
			})
			.then((res) => {


				list.splice(index, 1);
				setRowsData(list)
				setBatchData(list)


			})
			.catch((err) => {

				window.alert(err.response.data.message)

			});
	}


	const fileDownload = () => {

		const csvData = rowsData.map((row) => Object.values(row).join(",")).join("\n");
		const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
		saveAs(blob, `${window.location.pathname}_${currentDate.getDate() + "-" + currentDate.getMonth() + "-" + currentDate.getFullYear() + "-" + currentDate.getHours() + ":" + currentDate.getMinutes() + ":" + currentDate.getSeconds()}.csv`);


	}

	const handleStudentNav = (batch_id, batch_name) => {
		//for the url go to the collage data
		navigate(``, { state: { batch_id: batch_id, batch_name: batch_name } })


	}


	const handleGenerateLink = async () => {

		try {
			const body = {
				college_id: college_data_id,
				form_details: JSON.stringify({ name: "", contact: "" }),
				programs: BatchData,
			}

			const res = await service.post(`${process.env.REACT_APP_API_URL}/superAdmin/colleges/form-details`, body)
			setFormLink(res.data.data)

		} catch (error) {
			console.log("Error", error)
		}
	}

	const handleCopy = async () => {
		// Ensure navigator is available (i.e., we're on the client-side)
		if (!navigator.clipboard) {
			console.error("Clipboard API not available");
			return;
		}

		try {
			const linkToCopy = `${process.env.REACT_APP_FRONTEND_URL}/student-onboard/${formLink.hash_code}`
			await navigator.clipboard.writeText(linkToCopy);

			toast.success("Link Copied")

		} catch (error) {
			console.error("Failed to copy the link: ", error);
			// You could implement a fallback method here if needed
		}
	};


	return (<div >
		<RowsContext.Provider value={rowsData}>
			<TopBar />
			<SideNavigationBar />
			<ToastContainer position="bottom-right" />
			{loading ? <div style={{ position: "absolute", justifyContent: "center", alignItems: "center", margin: '0 auto' }}><Loader show={loading} /></div> : <>
				<div style={{ marginTop: "6rem", width: "90%", justifyContent: "space-between", display: "flex" }}>
					<div style={{ marginLeft: "200px" }}>
						<button style={{ backgroundColor: "transparent", border: "none" }} onClick={() => navigate(-1)}><ArrowBack /></button>
					</div>
					<div>
						<button className='batch-button' onClick={() => formLink ? handleCopy() : handleGenerateLink()}>{formLink ? "Copy Link " : "Generate Link"}</button>
					</div>
				</div>
				{
					college_data_name !== "" ?
						(<EnhancedTable batchTypeData={batchTypeData} programData={programData} handleStudentNav={handleStudentNav} college_name={college_data_name} mainFile_modal={Modal_JD} handleProcessDataPage={handleProcessDataPage} handleStudentDataPage={handleStudentDataPage} data_getter={data_getter} headCells={headCells} count={count} fileDownload={fileDownload} path={window.location.pathname} />) :
						(<EnhancedTable mainFile_modal={Modal_JD} data_getter={data_getter} headCells={headCells} count={count} fileDownload={fileDownload} path={window.location.pathname} />)

				}
			</>}

		</RowsContext.Provider>

	</div>
	)
}

export default UserType